/*
 * Compra de la landing de ebook. Los botones que en la referencia apuntaban a /checkout llevan data-ebl-checkout.
 *  - Por defecto van al enlace de compra de ⚙️ Configuración (Impultienda), o al enlace propio del botón.
 *  - Con data-ebl-carrito (opcional, solo para checkout de Shopify) agregan antes la variante al carrito,
 *    sin duplicarla, y muestran los errores en el elemento de error original de la referencia.
 * El aspecto del botón no cambia en ningún caso.
 */
(function () {
  if (window.EBLCompra) return;

  var enCurso = false;
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  function enlaceGlobal() {
    var el = document.querySelector('[data-ebl-enlace-compra]');
    return el ? el.getAttribute('data-ebl-enlace-compra') : '';
  }

  function aplicarEnlaces() {
    var url = enlaceGlobal();
    if (!url) return;
    document.querySelectorAll('.ebl [data-ebl-enlace-global]').forEach(function (a) { a.setAttribute('href', url); });
  }

  function mostrarError(link, mensaje) {
    var box = link.parentElement && link.parentElement.querySelector('[data-ebl-error]');
    if (box) { box.textContent = mensaje; box.style.display = 'block'; } else { window.alert(mensaje); }
  }

  function yaEnCarrito(variantId) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.items.some(function (i) { return String(i.variant_id) === String(variantId); }); });
  }

  function agregar(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.description || body.message || 'No se pudo agregar el producto.');
        return body;
      });
    });
  }

  function onClick(ev) {
    var link = ev.target.closest('[data-ebl-checkout]');
    if (!link || !link.closest('.ebl')) return;
    var destino = link.hasAttribute('data-ebl-enlace-global') ? enlaceGlobal() : link.getAttribute('href');
    if (!destino || destino.charAt(0) === '#') {
      ev.preventDefault();
      mostrarError(link, 'Falta configurar el enlace de compra.');
      return;
    }
    if (!link.hasAttribute('data-ebl-carrito')) return; // enlace directo (Impultienda): navegación normal
    ev.preventDefault();
    var src = document.querySelector('[data-ebl-variant-id]');
    var variantId = src && src.getAttribute('data-ebl-variant-id');
    var msg = (document.querySelector('[data-ebl-msg-sin-producto]') || link).getAttribute('data-ebl-msg-sin-producto') || 'No pudimos agregar el producto.';
    if (!variantId) { mostrarError(link, msg); return; }
    if (enCurso) return;
    enCurso = true;
    link.setAttribute('aria-busy', 'true');
    yaEnCarrito(variantId)
      .then(function (esta) { return esta ? null : agregar(variantId); })
      .then(function () { window.location.href = destino; })
      .catch(function (err) {
        enCurso = false;
        link.removeAttribute('aria-busy');
        mostrarError(link, err.message || msg);
      });
  }

  aplicarEnlaces();
  document.addEventListener('DOMContentLoaded', aplicarEnlaces);
  document.addEventListener('shopify:section:load', aplicarEnlaces);
  document.addEventListener('click', onClick);
  window.EBLCompra = { agregar: agregar, aplicarEnlaces: aplicarEnlaces };
})();
